import React, { Component } from 'react';
import { observer } from 'mobx-react';

import Container from './Container';
import LoadingSpinner from './LoadingSpinner';
import ErrorPleaseTryAgain from './ErrorPleaseTryAgain';
import SuggestionsContainer from './SuggestionsContainer';
import Suggestion from './Suggestion';

@observer
export default class Suggestions extends Component {
  onChange = event => this.props.onChange(event);

  render() {
    const { isLoading, suggestions, value, hasRequestError } = this.props;
    let suggestionsDisplay = null;
    let showSuggestionBox = false;

    if (suggestions && suggestions.length) {
      showSuggestionBox = true;
    } else if (isLoading && (!value || hasRequestError)) {
      showSuggestionBox = true;
    } else if (hasRequestError) {
      showSuggestionBox = true;
    }

    if (isLoading) {
      suggestionsDisplay = <LoadingSpinner message={'Finding your address ...'} />;
    } else if (hasRequestError) {
      suggestionsDisplay = <ErrorPleaseTryAgain>Could not locate address, please try again.</ErrorPleaseTryAgain>;
    } else {
      suggestionsDisplay = suggestions.map((suggestion, index) => (
        <Suggestion
          value={suggestion.place_id}
          isChosen={value === suggestion.place_id}
          label={suggestion.description}
          onChange={this.onChange}
          key={index}
        />
      ));
    }

    return (
      <Container showSuggestionBox={showSuggestionBox}>
        <SuggestionsContainer>{suggestionsDisplay}</SuggestionsContainer>
      </Container>
    );
  }
}
